module.exports = __webpack_public_path__ + "img/mono_29.ea56c821.png";